import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { App } from "./app/App";
import "@fontsource-variable/league-spartan";
import "./styles/global.css";

const root = document.getElementById("root");

if (!root) {
  throw new Error("De app-root ontbreekt.");
}

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
